module.exports = __webpack_public_path__ + "img/logo2 20250618.0ffa75b1.png";